/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Race_ReadInputs */

const en_funnel_ob_race_read = /** @type {(inputs: Funnel_Ob_Race_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading`)
};

const es_funnel_ob_race_read = /** @type {(inputs: Funnel_Ob_Race_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leyendo`)
};

/**
* | output |
* | --- |
* | "Reading" |
*
* @param {Funnel_Ob_Race_ReadInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_race_read = /** @type {((inputs?: Funnel_Ob_Race_ReadInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Race_ReadInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_race_read(inputs)
	return en_funnel_ob_race_read(inputs)
});